import { useNavigate, Link } from "react-router-dom";
import { HankoProfile } from "../components/HankoProfile";
import { ApiKeysSection } from "../components/ApiKeysSection";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import "../styles/hanko.css";

function SectionHeader({ icon, title }: { icon: string; title: string }) {
  return (
    <div className="flex items-center gap-2 border-l-4 border-primary pl-3 mb-5">
      <span className="material-symbols-outlined text-primary">{icon}</span>
      <h3 className="text-xl font-bold">{title}</h3>
    </div>
  );
}

export function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="max-w-3xl mx-auto w-full px-6 py-8">
      {/* Breadcrumb and Header */}
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <div className="flex flex-col gap-2">
          {/* Breadcrumbs */}
          <div className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
            <Link to="/projects" className="hover:text-primary transition-colors flex items-center gap-1">
              <span className="material-symbols-outlined text-[18px]">folder_open</span>
              Projects
            </Link>
            <span className="material-symbols-outlined text-[16px]">chevron_right</span>
            <span className="font-medium text-foreground">Profile</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-black tracking-tight">Account Settings</h1>
          {user?.email && (
            <p className="text-muted-foreground flex items-center gap-2">
              <span className="material-symbols-outlined text-[18px]">mail</span>
              {user.email}
            </p>
          )}
        </div>
        <Button variant="outline" onClick={() => navigate("/projects")} className="shadow-sm">
          <span className="material-symbols-outlined text-[20px]">arrow_back</span>
          Back to Projects
        </Button>
      </div>

      <div className="space-y-8">
        {/* Account Section */}
        <section>
          <SectionHeader icon="person" title="Account" />
          <div className="p-6 rounded-xl bg-card border border-border shadow-sm">
            <HankoProfile />
          </div>
        </section>

        {/* API Keys Section */}
        <section>
          <SectionHeader icon="key" title="API Keys" />
          <div className="p-6 rounded-xl bg-card border border-border shadow-sm">
            <ApiKeysSection />
          </div>
        </section>

        {/* Danger Zone */}
        <section>
          <SectionHeader icon="warning" title="Session" />
          <div className="p-6 rounded-xl bg-card border border-border shadow-sm">
            <p className="text-muted-foreground text-sm mb-4">
              Sign out of your current session on this device.
            </p>
            <Button variant="destructive" onClick={handleLogout}>
              <span className="material-symbols-outlined text-[20px]">logout</span>
              Sign Out
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
}
